import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications, PURCHASE_ANCHOR } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let cancelled = false;
    const show = window.setTimeout(() => {
      if (!cancelled) setVisible(true);
    }, 6000);
    return () => {
      cancelled = true;
      window.clearTimeout(show);
    };
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const cycle = window.setInterval(() => {
      setIndex(i => (i + 1) % purchaseNotifications.length);
      setVisible(true);
    }, 15000);
    return () => window.clearInterval(cycle);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 6500);
    return () => window.clearTimeout(hide);
  }, [visible, index, dismissed]);
  const person = purchaseNotifications[index];
  const minutes = index * 7 % 18 + 2;
  return <AnimatePresence data-id="element-132" data-mp="29pireer6fc58">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[16.5rem] max-w-[calc(100vw-1.5rem)]" data-id="element-133" data-mp="29nxyetkig19h">
          <a href={PURCHASE_ANCHOR} className="flex items-start gap-2 rounded-xl border-2 border-gold bg-white p-2.5 shadow-[0_10px_25px_-8px_rgba(18,61,56,0.6)] ring-2 ring-sage/40" data-id="element-134" data-mp="2sg0fg612djk9">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-sage" strokeWidth={2.5} data-id="element-135" data-mp="y3kcbe3keljm" />
            <div className="min-w-0" data-id="element-136" data-mp="1336qpqv4q7u0">
              <p className="font-heading text-[0.72rem] font-extrabold uppercase leading-tight text-petrol" data-id="element-137" data-mp="uzutj255i88i">
                {person.name}
              </p>
              <p className="truncate text-[0.7rem] leading-snug text-deep/80" data-id="element-138" data-mp="q3xohrzc8ob1">
                {person.city}, {person.country}
              </p>
              <p className="mt-0.5 text-[0.7rem] font-semibold leading-snug text-petrol" data-id="element-139" data-mp="zypk4q9d1136">
                just purchased CAREGIVER READY™
              </p>
              <p className="text-[0.62rem] uppercase tracking-wide text-gold" data-id="element-140" data-mp="1dx5quh782rlb">
                {minutes} minutes ago
              </p>
            </div>
          </a>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute -right-2 -top-2 rounded-full border border-gold bg-white p-1 text-petrol shadow" data-id="element-141" data-mp="1nos9uzpsxuym">
            <XIcon className="h-3 w-3" data-id="element-142" data-mp="1soy3umjjntjv" />
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}